// 默认百分比保留小数位数
export const DEFAULT_PERCENTAGE_FRACTION_DIGITS = 0;

// 默认百分之最大最小值限制（最大999%，最小-999%）
export const DEFAULT_PERCENTAGE_LIMIT = 999;
